import React from 'react';
import { X } from 'lucide-react';
import { combineThemeClasses } from '../../utils/theme';

const FullscreenWindow = ({ 
  children, 
  onClose,
  title,
  theme = 'dark'
}) => {
  return (
    <div 
      className="fixed inset-0 flex justify-center md:backdrop-blur-sm md:bg-black/30"
      style={{ 
        zIndex: 99999,
      }}
    >
      {/* Mobile: 100% width/height (true fullscreen), Desktop: 80% width centered */}
      <div 
        className={`relative w-full h-full md:w-4/5 md:h-full flex flex-col bg-slate-900
                   animate-in fade-in-0 duration-200`}
      >
        {/* Mobile Header Bar - Compact for mobile */}
        <div className="md:hidden flex-none flex items-center justify-between px-3 py-2 bg-slate-800 border-b border-slate-700">
          <span className="text-white text-sm font-medium truncate">
            {title || 'App'}
          </span>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg bg-slate-700 hover:bg-slate-600 transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4 text-white" />
          </button>
        </div>

        {/* Content Area */}
        <div className="flex-1 relative overflow-hidden">
          {children}
        </div>

        {/* Desktop Close Button - Outside the window */}
        <button
          onClick={onClose}
          className="hidden md:block absolute -right-16 top-4 p-2.5 rounded-full 
                     bg-black/50 hover:bg-black/70 
                     transition-colors group"
          aria-label="Close fullscreen window"
        >
          <X 
            className="w-6 h-6 text-white/70 group-hover:text-white/90 
                       transition-colors" 
          />
        </button>
      </div>
    </div>
  );
};

export default FullscreenWindow;